import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M29.134 13.066c0-.698-.59-1.264-1.288-1.264h-2.492c-.122 0-.244.014-.363.04l-2.328.519v1.968l1.604-.342v1.375l1.532-2.209-1.12 3.056-2.732.655a.812.812 0 10.379 1.58l3.155-.757a.813.813 0 00.574-.51l1.236-3.375-.42 3.474c-.055.448-.508 1.045-1.198 1.21l-1.38.337v10.084c0 .604.513 1.093 1.117 1.093s1.093-.49 1.093-1.093v-8.776h.457c-.025.161-.01-.35.011 8.779.002.603.491 1.09 1.093 1.09h.003c.604-.002 1.069-.493 1.067-1.096-.007-2.183 0-15.633 0-15.838zM28.837 9.011a2.011 2.011 0 11-4.023 0 2.011 2.011 0 014.023 0zM12.611 17.347l-1.028-2.438 1.529 2.068a.92.92 0 00.332.278l3.128 1.547a.92.92 0 00.815-1.648l-2.929-1.449-1.396-1.889 1.473 1.233.004.002v-1.786a1.263 1.263 0 00-1.236-1.006H10.99c-.697 0-1.262.565-1.262 1.262v7.054l.655 3.39-2.268 4.473a1.076 1.076 0 001.92.972l2.433-4.802c.108-.213.142-.456.097-.69l-.649-3.343h.372l.88 3.507-.75 4.672a1.075 1.075 0 102.124.34l.785-4.89c.023-.143.017-.29-.019-.431l-.744-3.198v-2.071l-1.397-.691c-.121-.078-.417-.134-.557-.466z" />
        <Path d="M21.982 12.842a.679.679 0 00-.68-.679H15.94a.679.679 0 00-.68.679v2.566l2.402 1.188c.548.27.864.823.859 1.396h1.196l-.002-.015V16.75a.147.147 0 00-.147-.147h-.037a.147.147 0 01-.104-.25l.769-.77a.147.147 0 01.208 0l.757.758c.175-.13.376-.224.594-.276l.227-.054v-3.17zM13.215 11.37a1.9 1.9 0 001.108-1.177l-1.372-.48 2.591.096a.458.458 0 00.017-.915l-1.297-.048a1.903 1.903 0 10-1.047 2.523z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
